"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22781],{

/***/ 22781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HomePage_HeroHomeImg; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
;// CONCATENATED MODULE: ./node_modules/imgix-url-builder/dist/index.mjs
const camelCaseToParamCase = (input) => {
  return input.replace(/[A-Z]/g, (match) => {
    return `-${match.toLowerCase()}`;
  });
};
const buildURL = (url, params) => {
  const instance = new URL(url);
  for (const camelCasedParamKey in params) {
    const paramKey = camelCaseToParamCase(camelCasedParamKey);
    const paramValue = params[camelCasedParamKey];
    if (paramValue === void 0) {
      instance.searchParams.delete(paramKey);
    } else if (Array.isArray(paramValue)) {
      instance.searchParams.set(paramKey, paramValue.join(","));
    } else {
      instance.searchParams.set(paramKey, `${paramValue}`);
    }
  }
  const s = instance.searchParams.get("s");
  if (s) {
    instance.searchParams.delete("s");
    instance.searchParams.append("s", s);
  }
  return instance.toString();
};

const buildPixelDensitySrcSet = (url, { pixelDensities, ...params }) => {
  return pixelDensities.map((dpr) => {
    return `${buildURL(url, { ...params, dpr })} ${dpr}x`;
  }).join(", ");
};

const buildWidthSrcSet = (url, { widths, ...params }) => {
  return widths.map((width) => {
    return `${buildURL(url, { ...params, w: void 0, width })} ${width}w`;
  }).join(", ");
};

class Client {
  constructor(options) {
    this.baseURL = options.baseURL;
  }
  buildURLForPath(path, params = {}) {
    return buildURL(`${new URL(path, this.baseURL)}`, params);
  }
  buildWidthSrcSetForPath(path, params) {
    return buildWidthSrcSet(`${new URL(path, this.baseURL)}`, params);
  }
  buildPixelDensitySrcSetForPath(path, params) {
    return buildPixelDensitySrcSet(`${new URL(path, this.baseURL)}`, params);
  }
}


//# sourceMappingURL=index.mjs.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/helpers/dist/isFilled.js
const isNonNullish = (input) => {
  return input != null;
};
const isNonEmptyArray = (input) => {
  return !!input.length;
};
const richText = (field) => {
  if (!isNonNullish(field)) {
    return false;
  } else if (field.length === 1 && "text" in field[0]) {
    return !!field[0].text;
  } else {
    return !!field.length;
  }
};
const title = (/* unused pure expression or super */ null && (richText));
const imageThumbnail = (thumbnail) => {
  return isNonNullish(thumbnail) && !!thumbnail.url;
};
const isFilled_image = (/* unused pure expression or super */ null && (imageThumbnail));
const isFilled_link = (field) => {
  return isNonNullish(field) && ("id" in field || "url" in field);
};
const linkToMedia = (/* unused pure expression or super */ null && (isFilled_link));
const contentRelationship = (/* unused pure expression or super */ null && (isFilled_link));
const date = (/* unused pure expression or super */ null && (isNonNullish));
const timestamp = (/* unused pure expression or super */ null && (isNonNullish));
const color = (/* unused pure expression or super */ null && (isNonNullish));
const number = (/* unused pure expression or super */ null && (isNonNullish));
const keyText = (field) => {
  return isNonNullish(keyText) && !!field;
};
const isFilled_select = (/* unused pure expression or super */ null && (isNonNullish));
const isFilled_embed = (field) => {
  return isNonNullish(field) && !!field.embed_url;
};
const geoPoint = (field) => {
  return isNonNullish(field) && "longitude" in field;
};
const integrationFields = (/* unused pure expression or super */ null && (isNonNullish));
const group = (group2) => {
  return isNonNullish(group2) && isNonEmptyArray(group2);
};
const sliceZone = (slices) => {
  return isNonNullish(slices) && isNonEmptyArray(slices);
};

//# sourceMappingURL=isFilled.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/lib/__PRODUCTION__.js
const __PRODUCTION__ = "production" === "production";

//# sourceMappingURL=__PRODUCTION__.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/package.js
const version = "0.1.9";

//# sourceMappingURL=package.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/lib/devMsg.js

const devMsg = (slug) => {
  return `https://prismic.dev/msg/next/v${version}/${slug}`;
};

//# sourceMappingURL=devMsg.js.map

;// CONCATENATED MODULE: ./node_modules/@prismicio/next/dist/PrismicNextImage.js






const castInt = (input) => {
  if (typeof input === "number" || typeof input === "undefined") {
    return input;
  } else {
    const parsed = Number.parseInt(input);
    if (Number.isNaN(parsed)) {
      return void 0;
    } else {
      return parsed;
    }
  }
};
const imgixLoader = (args) => {
  const url = new URL(args.src);
  const params = {
    fit: url.searchParams.get("fit") || "max",
    w: args.width,
    h: void 0
  };
  if (args.quality) {
    params.q = args.quality;
  }
  return buildURL(args.src, params);
};
const PrismicNextImage = ({
  field,
  imgixParams = {},
  alt,
  fallbackAlt,
  layout = "intrinsic",
  ...restProps
}) => {
  if (!__PRODUCTION__) {
    if (typeof alt === "string" && alt !== "") {
      console.warn(`[PrismicNextImage] The "alt" prop can only be used to declare an image as decorative by passing an empty string (alt="") but was provided a non-empty string. You can resolve this warning by removing the "alt" prop or changing it to alt="". For more details, see ${devMsg("alt-must-be-an-empty-string")}`);
    }
    if (typeof fallbackAlt === "string" && fallbackAlt !== "") {
      console.warn(`[PrismicNextImage] The "fallbackAlt" prop can only be used to declare an image as decorative by passing an empty string (fallbackAlt="") but was provided a non-empty string. You can resolve this warning by removing the "fallbackAlt" prop or changing it to fallbackAlt="". For more details, see ${devMsg("alt-must-be-an-empty-string")}`);
    }
  }
  if (imageThumbnail(field)) {
    const src = buildURL(field.url, imgixParams);
    const ar = field.dimensions.width / field.dimensions.height;
    let resolvedWidth = field.dimensions.width;
    let resolvedHeight = field.dimensions.height;
    if ((layout === "intrinsic" || layout === "fixed") && ("width" in restProps || "height" in restProps)) {
      const castedWidth = castInt(restProps.width);
      const castedHeight = castInt(restProps.height);
      if (castedWidth) {
        resolvedWidth = castedWidth;
      } else {
        if (castedHeight) {
          resolvedWidth = ar * castedHeight;
        }
      }
      resolvedHeight = resolvedWidth / ar;
    }
    return (0,jsx_runtime.jsx)(next_image["default"], {
      src,
      width: layout === "fill" ? void 0 : resolvedWidth,
      height: layout === "fill" ? void 0 : resolvedHeight,
      alt: alt != null ? alt : field.alt || fallbackAlt,
      loader: imgixLoader,
      layout,
      ...restProps
    });
  } else {
    return null;
  }
};

//# sourceMappingURL=PrismicNextImage.js.map

;// CONCATENATED MODULE: ./components/HomePage/HeroHomeImg.tsx



var HeroHomeImg = function(param) {
    var src = param.src, classes = param.classes, isMobile = param.isMobile, isDesktopXL = param.isDesktopXL;
    if (src && src.url) {
        var imgSrc = src;
        if (isMobile) {
            imgSrc = src['md'];
        } else if (!isDesktopXL) {
            imgSrc = src['lg'];
        }
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)(PrismicNextImage, {
            field: imgSrc,
            className: classes,
            alt: (src === null || src === void 0 ? void 0 : src.alt) ? src === null || src === void 0 ? void 0 : src.alt : '',
            layout: "fill",
            priority: true,
            objectFit: "cover",
            quality: 100,
            imgixParams: {
                cs: 'srgb'
            }
        }));
    } else {
        return null;
    }
};
/* harmony default export */ var HomePage_HeroHomeImg = (HeroHomeImg);


/***/ })

}]);